import Columns from './components/ContentList/Columns';
import ContentCard from './components/ContentList/ContentCard';
import Main from './components/ContentList/Main';
import GeneralList from './components/ContentList/GeneralList';
import Pagination from './components/ContentList/Pagination';
import FilterSheet from './components/ContentList/FilterSheet';

window.ContentList = {
    FilterSheet,
    Columns,
    ContentCard,
    Main,
    GeneralList,
    Pagination,
};
